import api from './api';

export type StudentMatchStrategy = 'cpf_then_name' | 'name_only';

export interface BackupSourceTurma {
  gradeId: string;
  level: string;
  levelLabel: string;
  shift: string;
  shiftLabel: string;
  year: number;
  enrollments: number;
  label: string;
}

export interface BackupImportSummary {
  totalEnrollments: number;
  studentsToCreate: number;
  contractsToInsert: number;
  contractsAlreadyExist: number;
  unresolvedEnrollments: number;
  missingResponsibleLinks: number;
  contractsWithMainResponsible: number;
  contractsWithAlternativeResponsible: number;
  contractsWithBothResponsibles: number;
  contractsWithRoleConflict: number;
}

export interface BackupImportResponse {
  sourceClass: {
    gradeId: string;
    level: string;
    levelLabel: string;
    shift: string;
    shiftLabel: string;
    year: number;
  };
  destination: {
    turmaId: number;
    turmaNome: string;
    turmaSerie: string;
    turmaAno: number;
    anoLetivoId: number;
  };
  summary: BackupImportSummary;
  unresolvedItems: Array<{
    enrollmentId: string;
    studentName: string | null;
    studentCpf: string | null;
    reason: string | null;
  }>;
  missingResponsibleLinks: Array<{
    enrollmentId: string;
    role: 'principal' | 'alternativo';
    cpf: string;
    nome: string | null;
  }>;
  roleConflicts: Array<{
    enrollmentId: string;
    studentName: string | null;
    responsavelNome: string | null;
  }>;
  execution?: {
    createdStudents: number;
    insertedContracts: number;
    linkedResponsibles: number;
    updatedStudentTurma: number;
  };
}

export const backupImportService = {
  async listSourceTurmas(ano?: number): Promise<BackupSourceTurma[]> {
    const { data } = await api.get<BackupSourceTurma[]>('/import-backup/turmas-origem', {
      params: ano ? { ano } : undefined,
    });
    return data;
  },

  async preview(params: {
    gradeId: string;
    turmaId: number;
    matchStrategy: StudentMatchStrategy;
    createMissingStudents: boolean;
  }): Promise<BackupImportResponse> {
    const { data } = await api.get<BackupImportResponse>('/import-backup/preview', {
      params,
    });
    return data;
  },

  async execute(payload: {
    gradeId: string;
    turmaId: number;
    matchStrategy: StudentMatchStrategy;
    createMissingStudents: boolean;
    updateStudentTurma: boolean;
  }): Promise<BackupImportResponse> {
    const { data } = await api.post<BackupImportResponse>('/import-backup/executar', payload);
    return data;
  },
};
